import { render } from "./BackupScheduleWizard.vue?vue&type=template&id=4944d1d2&scoped=true"
import script from "./BackupScheduleWizard.vue?vue&type=script&lang=js"
export * from "./BackupScheduleWizard.vue?vue&type=script&lang=js"

import "./BackupScheduleWizard.vue?vue&type=style&index=0&id=4944d1d2&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4944d1d2"]])

export default __exports__